export default __webpack_public_path__ + "media/music/18aea0f2cfec9eeac745bf8e51f2d945.mp3";